import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTCheckbox, { KTCheckboxStyle, KTCheckboxType } from 'general/components/OtherKeenComponents/KTFormControls/KTCheckbox';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import CustomDropdownMultiChoiceView from 'general/components/quybka/Others/CustomDropdownMultiChoiceView';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

ChargeTransactionListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
  initialSelectedChargeStation: PropTypes.object,
  onSelectedChargeStationChange: PropTypes.func,
};

function ChargeTransactionListFilterView({
  onCancel,
  onApply,
  closeDropdown,
  initialSelectedChargeStation,
  onSelectedChargeStationChange,
}) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterVehicleType, setFilterVehicleType] = useState('');
  const [filterStationId, setFilterStationId] = useState('');
  const [selectedChargeStation, setSelectedChargeStation] = useState(null);
  const [filterDateFilter, setFilterDateFilter] = useState(null);
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  const [filterTestTransaction, setFilterTestTransaction] = useState(0);
  useEffect(() => {
    setFilterQ(ChargeHelper.Filter.chargeTransactionList.q);
    setFilterStatus(ChargeHelper.Filter.chargeTransactionList.status);
    setFilterVehicleType(ChargeHelper.Filter.chargeTransactionList.vehicleType);
    setFilterStationId(ChargeHelper.Filter.chargeTransactionList.stationId);
    setFilterDateFilter(ChargeHelper.Filter.chargeTransactionList.dateFilter);
    setFilterFrom(ChargeHelper.Filter.chargeTransactionList.from);
    setFilterTo(ChargeHelper.Filter.chargeTransactionList.to);
    setFilterTestTransaction(ChargeHelper.Filter.chargeTransactionList.isTestTransaction);
  }, []);
  useEffect(() => {
    setSelectedChargeStation(initialSelectedChargeStation);
  }, [initialSelectedChargeStation]);
  const [timeFilterType, setTimeFilterType] = useState('START_TIME');

  const dropdownChargeStationEl = useMemo(() => {
    return (
      <CustomDropdownMultiChoiceView
        id="stationId"
        name="stationId"
        toggleElement={({ showError }) => (
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
            type="button"
          >
            {selectedChargeStation?.length > 0 ? selectedChargeStation.map(item => item.name).join(', ') : 'Chọn trạm sạc'}
          </button>
        )}
        selectedValue={selectedChargeStation}
        dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
        getSubItems={async (item) => {
          try {
            return await ChargeHelper.API.requestGetChargeStationList(
              Utils.filterParams({
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              })
            ).then((data) => {
              return {
                values: data.chargeStations?.map((station) => ({
                  id: station?.stationId,
                  name: station?.name,
                  item: station,
                })),
                total: data.total,
              };
            });
          } catch (error) {
            console.error('Error fetching station list:', error);
            return { values: [], total: 0 };
          }
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedChargeStation(value);
          setFilterStationId(value?.length > 0 ? value.map(item => item.id).join(', ') : '');
        }}
        enableCheckValid
        isDropdownForm={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        defaultValue={{
          name: 'Trạm sạc',
          role: 'STATION',
        }}
        idCheckType='id'
      />
    );
  }, [selectedChargeStation]);
  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    ChargeHelper.Filter.chargeTransactionList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: filterStatus,
      vehicleType: filterVehicleType,
      stationId: filterStationId,
      q: filterQ,
      dateFilter: filterDateFilter,
      from: filterFrom,
      to: filterTo,
      isTestTransaction: filterTestTransaction,
    };
    if (onSelectedChargeStationChange) onSelectedChargeStationChange(selectedChargeStation);
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    setSelectedChargeStation(null);
    if (onSelectedChargeStationChange) onSelectedChargeStationChange(null);
    ChargeHelper.Filter.chargeTransactionList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      stationId: '',
      q: '',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      isTestTransaction: 0,
    };
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã phiên sạc, biển số xe, tên chủ xe, số điện thoại, dòng xe..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* trang thai */}
        <div className="col-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạng thái')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeTransactionStatusOptions,
                  (item) => item.value === filterStatus
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={ChargeHelper.Filter.chargeTransactionList?.status}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeTransactionStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* loai phuong tien */}
        <div className="col-6 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Loại phương tiện')}
          <KTBSDropdown
            name="vehicleType"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.vehicleTypeOptions,
                  (item) =>
                    item?.value === filterVehicleType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterVehicleType}
            dropdownMenuItems={[{ name: 'Tất cả', value: '' }, ...ChargeHelper.Data.vehicleTypeOptions]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterVehicleType(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* tram sac */}
        <div className="col-12 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạm sạc')}
          {dropdownChargeStationEl}
        </div>
        <div className="col-12 mb-4 px-4"
          style={{
            borderBottom: `1px dashed ${AppColors.gray[300]}`
          }}
        />
        <div className="d-flex align-items-end mb-2">
          <div className="radio-inline w-100">
            <div className="d-flex gap-5">
              <KTRadio
                name="startTime"
                label="Thời gian bắt đầu"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                onChange={() => {
                  setTimeFilterType('START_TIME')
                  setFilterDateFilter(ChargeHelper.Filter.chargeTransactionList.dateFilter);
                  setFilterFrom(ChargeHelper.Filter.chargeTransactionList.from);
                  setFilterTo(ChargeHelper.Filter.chargeTransactionList.to);
                }}
                checked={timeFilterType === 'START_TIME'}
              />
              <KTRadio
                name="endTime"
                label="Thời gian kết thúc"
                type={KTRadioType.outline}
                additionalClassName="radio-success"
                onChange={() => {
                  setTimeFilterType('END_TIME')
                  setFilterDateFilter(ChargeHelper.Filter.chargeTransactionList.dateFilter);
                  setFilterFrom(ChargeHelper.Filter.chargeTransactionList.from);
                  setFilterTo(ChargeHelper.Filter.chargeTransactionList.to);
                }}
                checked={timeFilterType === 'END_TIME'}
              />
            </div>
          </div>
        </div>
        {/* khoang thoi gian */}
        <div className="col-12 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel(timeFilterType === 'START_TIME' ? 'Thời gian bắt đầu' : 'Thời gian kết thúc')}
          <CustomDateRangePicker
            inlineMode={true}
            toggleElementBorderRadius={5}
            initialValue={filterDateFilter}
            filterComponent={ChargeHelper.Filter.chargeTransactionList}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterDateFilter(selectedValue);
              setFilterFrom(startDate);
              setFilterTo(endDate);
            }}
          />
        </div>
        <div className="col-12 mb-4 px-4"
          style={{
            borderBottom: `1px dashed ${AppColors.gray[300]}`
          }}
        />
        <div className='d-flex gap-2 align-items-center mb-4'>
          <span style={UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])}>
            Xem phiên sạc test
          </span>
          {UIHelper.buildToggleSwitch(
            filterTestTransaction,
            () => {
              setFilterTestTransaction(Number(!filterTestTransaction));
            }
          )}
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        <div className='d-flex gap-3'>
          {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
          {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
        </div>
      </div>
    </div>
  );
}

export default ChargeTransactionListFilterView;
